import { useEffect, useRef, useState } from "react"
import { polylineAtePonto, polylineAposPonto } from "./rotaServicosGeo"
import { htmlIconeGps } from "./rotaServicosIconeGps"
import {
	carregarGoogleMapsSdk,
	mapaGoogleRecusado,
	registrarUsoMapaProfissional
} from "../../../servicos/googleMapsProfissional"

const COR_COLETA = "#00ced1"
const COR_ENTREGA = "#f59e0b"
const ZOOM_PROFISSIONAL = 17

function corTipo(tipoPonto) {
	return tipoPonto === "coleta" ? COR_COLETA : COR_ENTREGA
}

function htmlParada(n, proximo, tipoPonto, contraRotacao) {
	const cor = corTipo(tipoPonto)
	const letra = tipoPonto === "coleta" ? "C" : "E"
	const tam = proximo ? 40 : 32
	const giro = contraRotacao ? `transform:rotate(${contraRotacao}deg);` : ""
	return `<div style="position:relative;width:${tam}px;height:${tam}px;${giro}">
		<div style="width:${tam}px;height:${tam}px;border-radius:50%;background:${cor};color:#fff;font-weight:800;font-size:${proximo ? 15 : 13}px;display:flex;align-items:center;justify-content:center;border:2px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,.28);">${letra}</div>
		<span style="position:absolute;right:-3px;bottom:-3px;min-width:16px;height:16px;padding:0 4px;border-radius:99px;background:#111;color:#fff;font-size:9px;font-weight:800;display:flex;align-items:center;justify-content:center;border:1.5px solid #fff;">${n}</span>
	</div>`
}

function htmlVoce(heading, iconeProf) {
	const gps = htmlIconeGps(heading, iconeProf)
	if (gps) return gps
	return `<div style="width:36px;height:36px;position:relative;">
		<div class="rs-seta" style="position:absolute;left:9px;top:4px;transform:rotate(${Number(heading) || 0}deg);"></div>
	</div>`
}

function overlayHtml(g, map, lat, lng, html, onClick) {
	const el = document.createElement("div")
	el.style.position = "absolute"
	el.style.transform = "translate(-50%, -50%)"
	el.style.zIndex = "2"
	el.innerHTML = html
	if (onClick) {
		el.addEventListener("click", (evento) => {
			evento.preventDefault()
			evento.stopPropagation()
			onClick()
		})
	}
	const overlay = new g.maps.OverlayView()
	const pos = { lat, lng }
	overlay.onAdd = function () {
		this.getPanes().overlayMouseTarget.appendChild(el)
	}
	overlay.draw = function () {
		const proj = this.getProjection()
		if (!proj) return
		const ponto = proj.fromLatLngToDivPixel(new g.maps.LatLng(pos.lat, pos.lng))
		if (!ponto) return
		el.style.left = `${ponto.x}px`
		el.style.top = `${ponto.y}px`
	}
	overlay.onRemove = function () {
		el.remove()
	}
	overlay.setMap(map)
	return {
		mover(latNova, lngNova) {
			pos.lat = latNova
			pos.lng = lngNova
			overlay.draw()
		},
		html(novo) {
			el.innerHTML = novo
		},
		remover() {
			overlay.setMap(null)
		}
	}
}

function pontosEnquadrar(positions, polyline) {
	const pts = []
	for (const p of positions || []) {
		if (Array.isArray(p) && Number.isFinite(p[0]) && Number.isFinite(p[1])) pts.push(p)
	}
	if (!Array.isArray(polyline) || !polyline.length) return pts
	const passo = polyline.length > 240 ? Math.ceil(polyline.length / 240) : 1
	for (let i = 0; i < polyline.length; i += passo) {
		const p = polyline[i]
		if (Array.isArray(p) && Number.isFinite(p[0]) && Number.isFinite(p[1])) pts.push(p)
	}
	return pts
}

export default function RotaServicosMapaGoogle({
	chave,
	dominio,
	onFalhar,
	pontos,
	polyline,
	posProf,
	heading,
	seguir,
	rotacao = 0,
	focoProf,
	onPararSeguir,
	onMapa,
	onSelect,
	onFecharSheet,
	tick,
	sheetPx,
	iconeProf,
}) {
	const elRef = useRef(null)
	const mapRef = useRef(null)
	const pulando = useRef(false)
	const ultimoFoco = useRef(0)
	const cliquePin = useRef(false)
	const [pronto, setPronto] = useState(false)

	useEffect(() => {
		let vivo = true
		let relogioFalha = 0
		let relogioUso = 0
		const falhaAnterior = window.gm_authFailure
		const desistir = () => {
			if (!vivo) return
			vivo = false
			onFalhar?.()
		}
		window.gm_authFailure = () => {
			desistir()
			if (typeof falhaAnterior === "function") falhaAnterior()
		}
		carregarGoogleMapsSdk(chave).then((ok) => {
			if (!vivo) return
			const g = window.google
			if (!ok || !g?.maps || !elRef.current) {
				desistir()
				return
			}
			const inicio = posProf
				? { lat: Number(posProf.la), lng: Number(posProf.lo) }
				: pontos[0]
					? { lat: Number(pontos[0].la), lng: Number(pontos[0].lo) }
					: { lat: -14.24, lng: -51.92 }
			const map = new g.maps.Map(elRef.current, {
				center: inicio,
				zoom: 14,
				minZoom: 4,
				maxZoom: 18,
				mapTypeControl: false,
				streetViewControl: false,
				fullscreenControl: false,
				zoomControl: false,
				clickableIcons: false,
				gestureHandling: "greedy"
			})
			mapRef.current = map
			map.addListener("dragstart", () => {
				if (pulando.current) return
				onPararSeguir?.()
			})
			map.addListener("click", () => {
				if (cliquePin.current) {
					cliquePin.current = false
					return
				}
				onFecharSheet?.()
			})
			onMapa?.({
				zoomIn() { map.setZoom(Math.min(18, (map.getZoom() || 14) + 1)) },
				zoomOut() { map.setZoom(Math.max(4, (map.getZoom() || 14) - 1)) }
			})
			setPronto(true)
			relogioFalha = window.setInterval(() => {
				if (mapaGoogleRecusado(elRef.current)) desistir()
			}, 400)
			relogioUso = window.setTimeout(() => {
				window.clearInterval(relogioFalha)
				if (!vivo || mapaGoogleRecusado(elRef.current)) {
					if (vivo) desistir()
					return
				}
				registrarUsoMapaProfissional(dominio)
			}, 8000)
		})
		return () => {
			vivo = false
			window.clearInterval(relogioFalha)
			window.clearTimeout(relogioUso)
			if (window.gm_authFailure !== falhaAnterior) window.gm_authFailure = falhaAnterior
			mapRef.current = null
			setPronto(false)
		}
	}, [chave, dominio])

	useEffect(() => {
		const map = mapRef.current
		const g = window.google
		if (!pronto || !map || !g?.maps) return undefined
		const linhas = []
		const pins = []
		const cor = (typeof window !== "undefined"
			&& getComputedStyle(document.documentElement).getPropertyValue("--primaria")?.trim()) || "#100940"
		const proximo = pontos[0]
		const trechoAtual = proximo && polyline?.length > 1 ? polylineAtePonto(polyline, proximo) : polyline
		const restoRota = proximo && polyline?.length > 1 ? polylineAposPonto(polyline, proximo) : []
		const desenhar = (lista, strokeColor, strokeWeight, opacity) => {
			if (!Array.isArray(lista) || lista.length < 2) return
			linhas.push(new g.maps.Polyline({
				map,
				path: lista.map(([lat, lng]) => ({ lat: Number(lat), lng: Number(lng) })),
				strokeColor,
				strokeOpacity: opacity,
				strokeWeight,
				clickable: false
			}))
		}
		desenhar(restoRota, cor, 5, 0.72)
		desenhar(trechoAtual, "#111", 6, 0.95)
		pontos.forEach((p) => {
			const ehProximo = proximo && p.key === proximo.key
			pins.push(overlayHtml(
				g,
				map,
				Number(p.la),
				Number(p.lo),
				htmlParada(p.parada, ehProximo, p.tipoPonto, rotacao),
				() => {
					cliquePin.current = true
					onSelect?.(p)
				}
			))
		})
		return () => {
			linhas.forEach((linha) => linha.setMap(null))
			pins.forEach((pin) => pin.remover())
		}
	}, [pronto, pontos, polyline, rotacao, onSelect])

	useEffect(() => {
		const map = mapRef.current
		const g = window.google
		if (!pronto || !map || !g?.maps || !posProf) return undefined
		const pin = overlayHtml(
			g,
			map,
			Number(posProf.la),
			Number(posProf.lo),
			htmlVoce(heading, iconeProf)
		)
		return () => pin.remover()
	}, [pronto, posProf?.la, posProf?.lo, heading, iconeProf])

	useEffect(() => {
		const map = mapRef.current
		const g = window.google
		if (!pronto || !map || !g?.maps) return undefined
		const giro = seguir && focoProf > 0
		const timer = window.setTimeout(() => {
			g.maps.event.trigger(map, "resize")
			if (!giro) {
				const locais = [
					...(posProf ? [[posProf.la, posProf.lo]] : []),
					...pontos.map((p) => [p.la, p.lo]),
				]
				const pts = pontosEnquadrar(locais, polyline)
				if (pts.length === 1) {
					map.setCenter({ lat: pts[0][0], lng: pts[0][1] })
					map.setZoom(15)
				} else if (pts.length > 1) {
					const bounds = new g.maps.LatLngBounds()
					pts.forEach(([lat, lng]) => bounds.extend({ lat, lng }))
					map.fitBounds(bounds, {
						top: 168,
						left: 92,
						right: 76,
						bottom: Math.max((sheetPx || 0) + 28, 148)
					})
				}
			}
			if (seguir && posProf) {
				const aproximar = giro && focoProf !== ultimoFoco.current
				if (aproximar) ultimoFoco.current = focoProf
				pulando.current = true
				map.panTo({ lat: Number(posProf.la), lng: Number(posProf.lo) })
				if (aproximar) map.setZoom(ZOOM_PROFISSIONAL)
				window.setTimeout(() => { pulando.current = false }, aproximar ? 700 : 400)
			}
		}, 80)
		return () => window.clearTimeout(timer)
	}, [pronto, tick, seguir, focoProf, posProf?.la, posProf?.lo, sheetPx, pontos, polyline])

	return <div ref={elRef} className="rs-mapa-google" />
}
